@let emailErrorMessage = emailErrorMessage$();
@let phoneErrorMessages = phoneErrorMessages$();

<form [formGroup]="form" padding>
  <div class="multi-fields">
    <rt-form-field>
      <rt-label
        >{{ 'tlc.current_user.dialog_2fa_sms.user_profile_form.data.first_name' | translate }}
      </rt-label>
      <rt-input rtProtectedControl formControlName="firstName" />
    </rt-form-field>
    <rt-form-field>
      <rt-label
        >{{ 'tlc.current_user.dialog_2fa_sms.user_profile_form.data.last_name' | translate }}
      </rt-label>
      <rt-input rtProtectedControl formControlName="lastName" />
    </rt-form-field>
  </div>
  <rt-form-field>
    <rt-label
      >{{ 'tlc.current_user.dialog_2fa_sms.user_profile_form.data.email' | translate }}
    </rt-label>
    <rt-input rtProtectedControl formControlName="email" [class.invalid]="emailErrorMessage" />
    @if (emailErrorMessage) {
      <span text-critical>{{ emailErrorMessage }}</span>
    }
  </rt-form-field>
  <rt-form-field>
    <rt-label
      >{{ 'tlc.current_user.dialog_2fa_sms.user_profile_form.data.phone' | translate }}
    </rt-label>
    <rt-phone-input
      rtProtectedControl
      formControlName="phone"
      [invalid]="phoneErrorMessages.length > 0"
    />
    @for (errorMessage of phoneErrorMessages; track $index) {
      <span text-critical>{{ errorMessage }}</span>
    }
  </rt-form-field>
  <rt-form-field>
    <rt-label
      >{{ 'tlc.current_user.dialog_2fa_sms.user_profile_form.avatar.label' | translate }}
    </rt-label>
    <div layout class="avatar-section">
      <tlc-avatar-input (avatarChanged)="cacheAvatarImg($event)" />
    </div>
  </rt-form-field>
  <rt-form-field>
    <rt-label
      >{{ 'tlc.current_user.dialog_2fa_sms.user_profile_form.language.label' | translate }}
    </rt-label>
    <rt-select
      rtProtectedControl
      formControlName="language"
      [options]="tellentAndCoreSupportedLanguagesOptions"
      [hasSearch]="false"
    />

    @if (hasSeats()) {
      <div (click)="toggle()" class="advanced-settings">
        <span>{{
          'tlc.current_user.dialog_2fa_sms.user_profile_form.language.advanced_settings' | translate
        }}</span>
        <rt-icon
          [name]="
            collapsedState() === CollapseState.Collapsed
              ? 'keyboard-arrow-down'
              : 'keyboard-arrow-up'
          "
        />
      </div>
      <div layout layout-vertical [@collapse]="collapsedState()">
        @if (isRecruiteeAvailable()) {
          <div class="brand-select-wrap">
            <div class="brand-box">
              <rt-icon name="tellent-apps-ats" class="logo" />
              <div class="brand-name">
                {{ 'tlc.common.brand.recruitee' | translate }}
                <span>
                  {{ 'tlc.common.brand_type.recruitee' | translate }}
                </span>
              </div>
            </div>
            <rt-select
              [options]="recruitmentSupportedLanguagesOptions"
              [hasSearch]="false"
              [adjustDropdownWidthOnOpen]="true"
              rtProtectedControl
              formControlName="recruiteeLanguage"
            />
          </div>
        }
        @if (isKiwiAvailable()) {
          <div class="brand-select-wrap">
            <div class="brand-box">
              <rt-icon name="tellent-apps-hr-bg" class="logo" />
              <div class="brand-name">
                {{ 'tlc.common.brand.hr' | translate }}
                <span>
                  {{ 'tlc.common.brand_type.hr' | translate }}
                </span>
              </div>
            </div>
            <rt-select
              [options]="tellentAndCoreSupportedLanguagesOptions"
              [hasSearch]="false"
              [adjustDropdownWidthOnOpen]="true"
              rtProtectedControl
              formControlName="kiwiLanguage"
            />
          </div>
        }
      </div>
    }
  </rt-form-field>
  <div class="multi-fields not-equal">
    <rt-form-field>
      <rt-label
        >{{ 'tlc.current_user.dialog_2fa_sms.user_profile_form.timezone' | translate }}
      </rt-label>
      <rt-select [options]="timeZoneOptions" rtProtectedControl formControlName="timezone" />
    </rt-form-field>
    <rt-form-field>
      <rt-label
        >{{ 'tlc.current_user.dialog_2fa_sms.user_profile_form.time_format.label' | translate }}
      </rt-label>
      <rt-select
        [options]="timeFormatOptions"
        [hasSearch]="false"
        rtProtectedControl
        formControlName="timeFormat"
      />
    </rt-form-field>
  </div>
  <rt-form-field class="week-start-day">
    <rt-label
      >{{ 'tlc.current_user.dialog_2fa_sms.user_profile_form.week_start_day.label' | translate }}
    </rt-label>
    <rt-select
      [options]="weekStartDayOptions"
      [hasSearch]="false"
      rtProtectedControl
      formControlName="weekStartDay"
    />
  </rt-form-field>
</form>

<div class="buttons-container" layout layout-full-width layout-justify-flex-end padding>
  <rt-button class="cancel-button" variant="plain" (click)="cancel()" margin-right-small-x
    >{{ 'tlc.common.cancel' | translate }}
  </rt-button>
  <rt-button
    variant="primary"
    [loading]="loading()"
    [disabled]="!(form.valid && form.dirty)"
    (click)="submit()"
    >{{ 'tlc.common.save' | translate }}
  </rt-button>
</div>
